import { useSyncExternalStore } from "react";

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", cb);
      return () => mql.removeEventListener("change", cb);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** < 640px — модалки и селекты открываются как bottom sheet. */
export const useIsMobile = () => useMediaQuery("(max-width: 639.98px)");
export const useIsTouch = () => useMediaQuery("(pointer: coarse)");
